import queryString from 'query-string';
import React from 'react';
import {
  ACTION_PRICING_MODAL,
  CATEGORY_GROWTH,
} from '../../constants/analytics';
import type { PlanFeatureKey } from '../../organization/PricingConfig';
import PricingModal from '../../organization/PricingModal';
import { track } from '../analytics';
import { UIActions } from '../../ui/uiSlice';
import type { Dispatch } from '../../app/redux/useAppSelector';

export const openPricingModal = (
  dispatch: Dispatch,
  highlight?: PlanFeatureKey,
) => {
  const isOnPricingPath = window.location.pathname === pricingPath();

  const returnPath = isOnPricingPath
    ? '/'
    : window.location.pathname + window.location.search;

  if (!isOnPricingPath) {
    window.history.pushState({}, '', pricingPath(highlight));
  }

  track(ACTION_PRICING_MODAL, {
    category: CATEGORY_GROWTH,
    feature: highlight,
  });

  dispatch(
    UIActions.openModal(
      ({ close }: { close: () => void }) => (
        <PricingModal
          close={() => {
            window.history.pushState({}, '', returnPath);
            close();
          }}
          highlight={highlight}
        />
      ),
      { disableOutsideClose: true },
    ),
  );
};

export default function pricingPath(highlight?: PlanFeatureKey) {
  return `/pricing${
    highlight ? `?${queryString.stringify({ highlight })}` : ''
  }`;
}
